import React from 'react';
import { PricingCard } from '../PricingCard';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { createStripeCheckoutSession } from '../StripePortalRedirect';
import { trackRedditEvent, trackGoogleEvent, trackLinkedInEvent } from '../../ad_tracking/ad_tracking';

const adTrackRestartSubscription = () => {
    const value = 25.0;
    const currency = 'USD';
    
    trackRedditEvent('Custom', {
        customEventName: 'Enter Payment Method Restart Subscription',
        value: value,  
        currency: currency,
        itemCount: 1,
        products: [{
            id: 'launch_preview',
            name: 'Preview Access',
            category: 'Subscription',
            price: value,
            quantity: 1
        }]
    });

    // We do NOT trackRedditEvent('Purchase') here because we don't want to double-count this
    // resubscription event.
    
    // "Restart Subscription" conversion event
    trackGoogleEvent('conversion', {
        'send_to': 'AW-17124613764/JV-1CNvdxdkaEIS90-U_',
        'value': value,
        'currency': currency
    });

    // "Restart Subscription" conversion event
    trackLinkedInEvent({ conversion_id: 20129700 });
}


export function CanceledSubCard({ isLoading }) {
    const { user } = useAuthenticator();
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);

    const handleSubscribe = async () => {
        setSubscriptionLoading(true);
        try {
            await createStripeCheckoutSession(user.signInUserSession.idToken.payload.sub, 'stripe_launch_preview_trial_price_id');

            adTrackRestartSubscription();

        } catch (error) {
            console.error('Failed to create Stripe checkout session:', error);
        } finally {
            setSubscriptionLoading(false);
        }        
        
    };

    return (
        <PricingCard
            productName="Your subscription has ended."
            description="To continue getting the most nuanced, data-driven company research and analysis available, activate your subscription by adding a payment method today. Cancel any time."
            price="$25"
            cycle="month"
            onPurchase={handleSubscribe}
            isLoading={isLoading || subscriptionLoading}
            error={null}
            confettiComponent={null}
            buttonText="Subscribe"
        />
    );
}

export default CanceledSubCard; 